/**
 * Extract a chart spec string from a create_chart tool_call event.
 *
 * During streaming the spec lives in `metadata.toolInput.spec`, but when
 * loaded from conversation history it's in `event.content` as
 * `{"spec": "…"}`.  This helper checks both locations.
 */
export function extractChartSpec(event: {
  content: string;
  metadata?: Record<string, unknown>;
}): string | null {
  const toolInput = event.metadata?.toolInput as
    | Record<string, unknown>
    | undefined;
  let spec: unknown = toolInput?.spec;

  if (!spec && event.content) {
    try {
      const parsed = JSON.parse(event.content);
      spec = parsed?.spec;
    } catch {
      /* not JSON */
    }
  }

  if (!spec) return null;
  return typeof spec === 'string' ? spec : JSON.stringify(spec);
}
